/**
 * featureFlags — build-time client feature gates.
 *
 * WHY THIS EXISTS (state-lessons epic, M4): the DSAT exam surface dark-launches
 * behind a BACKEND flag — every exam route 404s when off, so the frontend
 * self-hides on the 404 (see prepApi.isExamFeatureDark). The lesson routes are
 * different: `GET .../lesson` 404s ONLY when a node genuinely has no composed
 * lesson content — it is NOT flag-gated server-side. So a client-side flag is
 * the ONLY way to keep the dark launch invisible (PRD §4.5: "flag off = zero UI
 * change"). With the flag off we must never even PROBE for a lesson, never add a
 * "Just practice" control, never show the jurisdiction picker — the app renders
 * byte-identically to today.
 *
 * CONVENTION: the repo's only build-time config channel is `process.env
 * .REACT_APP_*` (see config.js's REACT_APP_API_URL) — Vite/CRA inline these at
 * build time. We read the value through a FUNCTION (not a module-level const) so
 * that (a) the inlining still happens at build, and (b) tests can drive the gate
 * by mocking this module (`jest.mock('./featureFlags')`) without reaching into
 * `process.env`. Default OFF: anything other than the exact string 'true' is
 * off, so a missing/typo'd/empty var can never accidentally light the feature.
 */

/**
 * True when the state-curriculum lesson surface (Learn mode, quick-check,
 * "Just practice", the "My state's standards" picker) is enabled for this
 * build. Off unless `REACT_APP_LESSONS_ENABLED === 'true'`.
 * @returns {boolean}
 */
export function lessonsEnabled() {
  return process.env.REACT_APP_LESSONS_ENABLED === 'true';
}
